<template>
  <td class="t-table-data">
    <div>
      <span :class="['t-table-data-sort', filterStyle]" @click="toggleSortOrder" :data-qe-id="qeId">
        <slot />
        <span class="t-table-data-sort-icon" v-if="sortFilter">
          <i class="icf-arrowTop" />
          <i class="icf-arrowBottom" />
        </span>
      </span>
      <span>
        <slot name="icon"></slot>
      </span>
    </div>
  </td>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SortOrder } from '@/model/ranking/Sorting'

const props = withDefaults(
  defineProps<{
    sortFilter: string
    isSelected: boolean
    sortOrder: string
    qeId: string
  }>(),
  { isSelected: false }
)
const emit = defineEmits(['toggle-sorting'])
const EVENT_TOGGLE_SORTING = 'toggle-sorting'
const styleMap: { [key: string]: string } = {
  [SortOrder.ASCENDING]: 't-table-data-sort-up',
  [SortOrder.DESCENDING]: 't-table-data-sort-down',
}
const filterStyle = computed((): string => {
  return props.isSelected ? styleMap[props.sortOrder] : ''
})

function toggleSortOrder() {
  if (props.sortFilter) {
    const sortOrder = props.sortOrder === SortOrder.ASCENDING ? SortOrder.DESCENDING : SortOrder.ASCENDING
    emit(EVENT_TOGGLE_SORTING, { filter: props.sortFilter, order: sortOrder })
  }
}
</script>
